import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-logout',
    templateUrl: '../signin/signin.component.html',
    styleUrls: ['../signin/signin.component.css'],
    providers: []
})
export class LogoutComponent implements OnInit {
    private _router;
    private vendor = {
        emailId: '',
        password: ''
    };
    public appVersion: any;

    /**
     * Creates an instance of LogoutComponent.
     * 
     * Removed all items in localstorage
     * @param {Router} router 
     * 
     * @memberof LogoutComponent
     */
    constructor(private router: Router) {
        this.appVersion = localStorage.getItem('appVersion');
        this._router = router;
        localStorage.removeItem('vendor');
        localStorage.removeItem('currentCategory');
        localStorage.removeItem('facility');
        localStorage.removeItem('facilityList');
        localStorage.removeItem('vendor_facilityData');
        localStorage.removeItem('category');
        localStorage.removeItem('memberEmailId');
        localStorage.removeItem('memberEmailId');
        localStorage.removeItem('recentCreatedGroupId');
        localStorage.removeItem('Wizard');
        this._router.navigate(['/']);
        setTimeout(function () {
            location.reload();
        });
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/authentication/logout/logout.component.ts